import { i18n } from '@/localization';
import {
    KLARNA_SUPPORTED_MARKETS,
    LEABANK_SUPPORTED_MARKETS,
} from './BookNowPayLater.config';
import { BookNowPayLaterStep, BookNowPayLaterType } from './BookNowPayLater.interfaces';
import { Type as AssetType } from '@ui/components/Asset/Asset.interfaces';
import { Cart, PaymentMethodType } from '@/api/Cart/cart.interfaces';

export function getType(
    market?: number,
    cart?: Cart,
    skipValidation?: boolean
): BookNowPayLaterType | undefined {
    if (!market) return undefined;

    if (KLARNA_SUPPORTED_MARKETS.includes(market)) {
        return BookNowPayLaterType.Klarna;
    }

    if (LEABANK_SUPPORTED_MARKETS.includes(market)) {
        if (skipValidation) return BookNowPayLaterType.LeaBank;

        if (hasLeaBankPaymentMethod(cart)) {
            return BookNowPayLaterType.LeaBank;
        }
    }

    return undefined;
}

function hasLeaBankPaymentMethod(cart?: Cart): boolean {
    return !!cart?.Payment?.PaymentMethods?.some((x) => x.Type === PaymentMethodType.LeaBank);
}

export function getAsset(type: BookNowPayLaterType | undefined): AssetType | undefined {
    switch (type) {
        case BookNowPayLaterType.Klarna:
            return 'Klarna';
        case BookNowPayLaterType.LeaBank:
            return 'LeaBankSmall';
        default:
            return undefined;
    }
}

export function getName(type: BookNowPayLaterType | undefined): string | undefined {
    switch (type) {
        case BookNowPayLaterType.Klarna:
            return 'Klarna';
        case BookNowPayLaterType.LeaBank:
            return 'Lea Bank';
        default:
            return undefined;
    }
}

export function getModalDescription(
    type: BookNowPayLaterType | undefined
): string | undefined {
    switch (type) {
        case BookNowPayLaterType.Klarna:
            return i18n.global.t('book_now_pay_later.description_klarna');
        case BookNowPayLaterType.LeaBank:
            return i18n.global.t('book_now_pay_later.description_leabank');
        default:
            return undefined;
    }
}

export function getModalSteps(name: string | undefined): BookNowPayLaterStep[] {
    if (!name) [];

    return [
        {
            step: 1,
            label: i18n.global.t('book_now_pay_later.choose_payment', [name]),
        },
        {
            step: 2,
            label: i18n.global.t('book_now_pay_later.choose_plan'),
        },
        {
            step: 3,
            label: i18n.global.t('book_now_pay_later.complete_payment'),
        },
    ];
}
